import React, {Component} from "react";
import PropTypes from "prop-types";
import {_getActivePlans} from "../../../../../services/apis/PlanAPI";
import TotalUsersByPlan from "./TotalUsersByPlan";

class UserByPlans extends Component {
    state = {
        plans: []
    };

    componentDidMount() {
        this._fetchPlans();
    }

    _fetchPlans = () => {
        _getActivePlans()
            .then(response => {
                const {success, data} = response;

                if (success) {
                    this.setState({
                        plans: data
                    });
                }
            });
    };

    render() {
        return (
            <div className="UserByPlans">
                {this.state.plans.map(plan => {
                    return (
                        <TotalUsersByPlan key={plan._id} plan={plan}/>
                    );
                })}
            </div>
        );
    }
}

UserByPlans.propTypes = {
    any: PropTypes.any
};

export default UserByPlans;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/statistic/UserByPlans/UserByPlans.js